import BaseAPI from "../api";

const path: string = "clusters";

export interface createClusters {
  clustersName: string;
  clustersNo: string;
  clustersStatus: string;
  idFiscalYear: number;
}

export interface updateCluster {
  clustersName: string;
  clustersNo: string;
  clustersStatus: string;
  idFiscalYear: number;
}

export interface getClusters {
  keyword?: string;
  page?: number;
  limit?: number;
  idFiscalYear?: number;
}

export class ClustersApi extends BaseAPI {
  public static createClusters(props: createClusters): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getClusters(props: getClusters): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updateClusters(
    idClusters: number,
    props: updateCluster
  ): Promise<any> {
    return this.api.patch(`${path}/${idClusters}`, props).then((res) => res);
  }
  public static getDetailClusters(idClusters: number): Promise<any> {
    return this.api.get(`${path}/${idClusters}`).then((res) => res);
  }
}
